<div class="modal-backdrop"></div>

<div class="modal-confirm" *ngIf="categorias">
    <div class="modal-conteudo">
        <div class="header-modal">
            <span>Avaliação</span>
            <img id="close-modal-btn" class='bt-fechar' (click)="onFechar()" src="assets/img/icons/close-white.svg">
        </div>
        <ng-container [ngTemplateOutlet]="paginaAtual === 'inicio' ? modalInicio : 
                                   paginaAtual === 'avaliacao' ? modalAvaliacao : 
                                   modalFinal">
        </ng-container>

        <ng-template #modalInicio>
            <div *ngIf="objPesquisa" class="modal-body-inicio">
                <div class="d-flex flex-column align-items-center">

                    <div class="estrelas-container">
                        <img width="48px" src="assets/img/star-gold.svg" alt="estrela">
                        <img width="48px" src="assets/img/star-gold.svg" alt="estrela">
                        <img width="48px" src="assets/img/star-gold.svg" alt="estrela">
                        <img width="48px" src="assets/img/star-gold.svg" alt="estrela">
                        <img width="48px" src="assets/img/star-gold.svg" alt="estrela">
                    </div>

                    <div class="d-flex flex-column align-items-center">
                        <h2 class="mt-4">
                            {{objPesquisa.Descricao}}
                        </h2>
                        <span class="mb-5 mt-2">
                            Compartilhe conosco sua experiência. É rapidinho.
                        </span>
                    </div>

                    <button class="btn-iniciar"
                            (click)="irParaAvaliacao()">
                        Iniciar
                        <img class="ms-2" src="assets/img/seta.svg" alt="">
                    </button>
                </div>
            </div>
        </ng-template>

        <ng-template #modalAvaliacao>
            <div class="modal-body-avaliacao">
                <div class="title">
                    <img src="assets/img/emoji-smile.svg" alt="">
                    <h2>Compartilhe conosco sua experiência. É rapidinho.</h2>
                </div>
                    <div *ngIf="!categorias?.length" class="loading">
                        <img width="50px" src="assets/img/loading2.gif" alt="">
                    </div>
                    <div *ngIf="categorias?.length" class="conteudo-avaliacao">
                        <div class="categorias">
                            <span class="subtitle">Classifique cada categoria de 1 a 5 estrelas.</span>
                            <div class="sections">
                                <section *ngFor="let item of categorias">
                                    <div>
                                        <h3>{{item.Descricao}}</h3>
                                        <p>{{item.Pergunta}}</p>
                                    </div>
                                    <div>
                                        <div class="container">
                                            <div class="nota justify-content-end">
                                                <p class="nota-pior">{{item.DescricaoCriterioRuim}}</p>
                                                <h3>1</h3>
                                            </div>
                                            <div class="estrelas">
                                                 <img
                                                    *ngFor="let estrela of item.estrelas"
                                                    height="22.5"
                                                    width="24"
                                                    class="me-2 btn_hover"
                                                    (click)="alterarAvaliacao(item, estrela.indice)"
                                                    (mouseenter)="setHover(item, estrela.indice)"
                                                    (mouseleave)="clearHover(item)"
                                                    [src]="(item.hoverIndex ? estrela.indice <= item.hoverIndex : estrela.selecionado)
                                                    ? 'assets/img/start_sel.svg'
                                                    : 'assets/img/start_vazia.svg'"
                                                >
                                            </div>
                                            <div class="nota justify-content-start">
                                                <h3>5</h3>
                                                <p>{{item.DescricaoCriterioBom}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </section> 
                            </div>
                        </div>
                        <div class="container-input">
                            <div class="descricao">
                                <span class="subtitle">Como você acha que podemos melhorar?</span>
                                <p>(Opcional)</p>
                            </div>
                            <textarea [(ngModel)]="observacao" class="text-area"> </textarea>
                            <p>Caracteres: 0/500</p>
                        </div>
                        <div class="d-flex justify-content-end">
                            <button class="btn-enviar" (click)="enviarRespostaAvaliacao()">
                                <img class="me-2" src="assets/img/icons/icon-check-white.svg" alt="" (click)="enviar()">
                                Enviar
                            </button>
                        </div>
                    </div>
                </div>
        </ng-template>
        <ng-template #modalFinal>
            <div class="modal-body">
                <div class="d-flex flex-column align-items-center container-text">
                    <img class="mb-4" src="assets/img/smile.svg" alt="">
                    <h1>Obrigado pelo seu feedback!</h1>
                    <span>Você pode fechar esta aba normalmente.</span>
                </div>
            </div>
        </ng-template>
    </div>
</div>
